import axios from 'axios';

// 'https://bmw-motorrad.uz'
// 'http://127.0.0.1:8000'
const BASE_URL = process.env.REACT_APP_API_URL || 'https://bmw-motorrad.uz';
const cleanBaseUrl = BASE_URL.replace(/\/+$/, '');

// 1. Создаем изолированный экземпляр Axios вместо прямого вызова axios(config)
const apiClient = axios.create({
    baseURL: cleanBaseUrl,
    timeout: 15000, // Защита фронтенда от DoS (если сервер завис, запрос прервется через 15 сек)
    // withCredentials: true, // КРИТИЧЕСКОЕ ИЗМЕНЕНИЕ: включает безопасную передачу Cookies (Sanctum) для защиты от сессионных атак
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

export const sendFrontAction = async (action, data = {}, method = 'POST') => {
    const currentMethod = method.toUpperCase();
    
    //Безопасное конфигурирование запроса
    const requestConfig = {
        method: currentMethod,
        url: `api/front/${action}`, // baseURL подставится автоматически
        // Если метод GET, данные идут в query, иначе в body
        [currentMethod === 'GET' ? 'params' : 'data']: data
    };


    try {
        const response = await apiClient(requestConfig);
        return response.data;
    } catch (error) {
        // Защита от утечки системной информации в консоль
        if (error.response && error.response.data) {
            throw error.response.data;
        }
        throw new Error('Не удалось установить безопасное соединение с сервером');
    }
    // just text line
};